import { useCurrentStateAndParams } from '@uirouter/react';
import { useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import utilSvc from '../../../../core/utilSvc';
import { pageStateAtom } from '../payor_list_atoms';
import { CLAIM_PAYOR_EDIT } from '../../payor_const';
import { pageStateVM } from '../../../../core/page/page_view_models';

export const usePayorListInit = (): void => {
    const route = useCurrentStateAndParams();
    const setState = useSetImmerAtom(pageStateAtom);

    // INIT
    useEffect(() => {
        setState(draft => {
            if (draft.init) {
                // get context from Angular
                const ctx = ngContext();
                draft.canEdit = !!ctx && !!ctx.User ? utilSvc.user.hasFeature(ctx.User, CLAIM_PAYOR_EDIT) : false;
                draft.init = false;
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setState(() => pageStateVM());
        };
    }, [route, setState]);
};
